<template>
    <div class="follow-list-wrapper">
        <EmptyPage :height="498" :loading="loading" v-if="list.length === 0" />
        <div v-else>
            <!-- 粉丝列表 -->
            <div class="follow-list">
                <div class="follow-list__item" v-for="(item, index) in list" :key="index">
                    <UserCard :data.sync="item" :showFollowBtn="isOwner"></UserCard>
                </div>
            </div>

            <div class="follow-list__pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :current-page="pageNum"
                    :total="total"
                    @current-change="handlePageChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getToken } from '@/utils/auth';
import { openWindow } from '@/utils/utils';
import { getMyFans, getMyAttentionUser } from '@/api/user';
import EmptyPage from '@/components/EmptyPage';
import UserCard from '@/views/components/UserCard';

export default {
    name: 'FollowList',
    components: { EmptyPage, UserCard },
    inject: ['backTop', 'checkToken'],
    props: {
        type: {
            type: [String, Number],
            default: ''
        }
    },
    data: () => ({
        id: null,
        loading: true,
        total: 0,
        pageSize: 20,
        pageNum: 1,
        pages: 1,
        list: [],
        avatarUrl: '/static/images/user.png'
    }),
    computed: {
        ...mapState('user', ['userInfo']),
        isOwner() {
            let isOwner = false;
            if (this.userInfo && this.id && this.userInfo.id === this.id) {
                isOwner = true;
            }
            return isOwner;
        }
    },
    watch: {
        type() {
            this.loading = true;
            this.list = [];
            this.initPageParams();
            this.getData();
        }
    },
    mounted() {
        const { id } = this.$route.params;
        if (id) {
            this.id = parseInt(id);
            this.initPageParams();
            this.getData();
        } else if (!id && getToken()) {
            this.$store.dispatch('user/getUserInfo').then(() => {
                this.id = this.userInfo.id;
                this.initPageParams();
                this.getData();
            });
        } else {
            this.$message.error('该用户不存在');
            this.$router.push({ name: 'Home' });
            return;
        }
    },
    methods: {
        initPageParams() {
            this.pageNum = 1;
            this.pageSize = 20;
            this.total = 0;
            this.pages = 1;
        },
        handlePageChange(pageNum) {
            this.pageNum = pageNum;
            this.backTop();
            this.getData();
        },
        async getData() {
            if (!this.id || this.type === '') return;
            try {
                let res = null;
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum
                };
                if (this.type == 0) {
                    params.id = this.id;
                    res = await getMyFans(params);
                } else if (this.type == 1) {
                    params.id = this.id;
                    res = await getMyAttentionUser(params);
                }
                const { code, data } = res;
                if (res && code === 0) {
                    this.list = data.result.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            create: item.publishCount,
                            follow: item.fansCount,
                            avatar: item.imageAddress,
                            imageList: item.list,
                            tp: item.tp,
                            isFollow: this.type === 1 ? true : item.isXiangHuAttention
                        };
                    });

                    this.total = data.total;
                    this.pages = data.pages;
                }
            } catch (e) {
                throw e;
            } finally {
                this.loading = false;
            }
        },
        openDetail(item) {
            let url = null;
            switch(item.tp) {
                case 1:
                    url = '/#/experience/detail/';
                    break;
                case 2:
                    url = '/#/works/detail/';
                    break;
                default:
                    break;
            }
            if (url) {
                openWindow(url + item.id);
            }
        },
        openUserDetail(id) {
            this.$router.push({
                name: 'User',
                params: { id }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.follow-list-wrapper {
    margin-top: 20px;
    overflow: hidden;
    border-radius: 10px;
    padding-bottom: 30px;
    background-color: rgba(255, 255, 255, 1);

    .follow-list {
        padding: 30px;
        min-height: 453px;
        &__item {
            &:not(:first-child) {
                margin-top: 40px;
            }
        }

        &__pagination {
            margin-top: 45px;
        }
    }
}

// 小屏
@include mq($small) {
    .follow-list-wrapper {
        margin-top: 15px;
        .follow-list {
            &__item {
                &:not(:first-child) {
                    margin-top: 30px;
                }
            }

            &__pagination {
                margin-top: 30px;
            }
        }
    }
}
</style>
